
function IsEmail(email) {
  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(!regex.test(email)) {
    return false;
  }else{
    return true;
  }
}

var personEmail='';


function trackUser(){
  klaviyo.push(['track', 'QuizBNStyleTaken']);
}

  var pushItems = [];

function addEmail(){

  personEmail = '';

if(!IsEmail($('#results-email').val())){
$( "#badEmail" ).html( 'Invalid email address.' );
  
  return;
}


if(!$('#agree').is(':checked')){
      $( "#badEmail" ).html( 'You must agree to the terms below.' );
  return;
}

  
$( "#badEmail" ).html('');
personEmail=$('#results-email').val();


 klaviyo.identify({
    'email' : personEmail
  });

  
   klaviyo.push(['identify', pushItems ,trackUser]); 






        $.ajax({
          type: "POST",
          url: "/contact",
          data: {
            "contact[email]":personEmail,
            "form_type":"customer",
            "contact[tags]":"newsletter",
            "utf8":"✓",
            "h-captcha-response":"",
          },
        });
      
$( "#results-email" ).parent().parent().parent().html( '<p>Thank you, an email with your results will be sent shortly.</p>' );


  
}





sameHeights = function (container) {
  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  jQuery(container).each(function () {

    $el = jQuery(this);
    jQuery($el).height('auto')
    topPostion = $el.position().top;              
    if (currentRowStart != topPostion) {
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {             
      rowDivs[currentDiv].height(currentTallest);
    }
  });
} 

//Quiz Logic 
var prodRecommended0 ='Beachy Texture Spray';
var prodRecommended1 ='Color Care Shampoo';
var prodRecommended2 = 'Color Care Deep Conditioning Balm';
var prodRecommended3 = "Moisturizing Shampoo";
var prodRecommended4 = "Moisturizing Conditioner";
var prodRecommended5 = "Moisture Replenishing Masque";
var prodRecommended6 ="Damage Repair Shampoo";
var prodRecommended7= "Damage Repair Conditioner";
var prodRecommended8 = "Damage Repair Strengthening Leave-In Cream";
var prodRecommended9= "Color Care Conditioner";
var prodRecommended10 = "Heat Styling Lotion";
var prodRecommended11= "Shine Glaze";
var prodRecommended12= "Always Color Care";
var prodRecommended13= "Always Damage Repair";
var prodRecommended14= "Always Moisturizing";
var prodRecommended15= "Hydrating Leave-In Milk";



  var _learnq = _learnq || [];


function quizLogic() {  
  
        var resultText = [];
         var setFlag = 0;
        var setConditioner = 0;
        var setShampoo = 0;

        var answer1 = $("input[name='question-1-answers']:checked").val();
//if (typeof ga != "undefined")
 //  ga('send', 'event', 'QUIZ', 'click', 'Q1',answer1);
        var answer3 = $("input[name='question-3-answers']:checked").val();
//if (typeof ga != "undefined")
//  ga('send', 'event', 'QUIZ', 'click', 'Q2',answer3);
        var answer4 = $("input[name='question-4-answers']:checked").val();
//if (typeof ga != "undefined")
//  ga('send', 'event', 'QUIZ', 'click', 'Q3',answer4);
        var answer5 = $("input[name='question-5-answers']:checked").val();
//if (typeof ga != "undefined")
//  ga('send', 'event', 'QUIZ', 'click', 'Q4',answer5);
  
  		
  
        var answer6 = [];
        $.each($("input[name='question-6-answers[]']:checked"), function() {
          //if (typeof ga != "undefined")
         // ga('send', 'event', 'QUIZ', 'click', 'Q5',$(this).val());
            answer6.push($(this).val());
        });
        var answer8 = $("input[name='question-8-answers']:checked").val();
//if (typeof ga != "undefined")
//  ga('send', 'event', 'QUIZ', 'click', 'Q6',answer8);
        var answer9 = [];
        $.each($("input[name='question-9-answers[]']:checked"), function() {
         //   if (typeof ga != "undefined") 
        //  ga('send', 'event', 'QUIZ', 'click', 'Q7',$(this).val());
            answer9.push($(this).val());
        }); 
  
        var goodProducts = [];
        var alwaysProducts = [];
        var numHairColor = 1;
        var numShampoo = 1;
        if (answer1 == 1) {
            if (answer6[0] != 8) {
                goodProducts.push(prodRecommended1);
            }
            //(fine, color treated)
            if (answer6[0] != 8 && answer3 <= 2) {
                goodProducts.push(prodRecommended1);
            }
            //(medium, course)
            if (answer3 > 1) {
                goodProducts.push(prodRecommended2);
                // array_push(goodProducts, prodRecommended2); 
            }
            //If not color treated (fine)
            if (answer6[0] == 8 && answer3 <= 2) {
                goodProducts.push(prodRecommended3, prodRecommended4);
            }
            //array_push(goodProducts, prodRecommended3,prodRecommended4);  }
            //If not color treated
            if (answer6[0] == 8 && answer3 == 4) {
                goodProducts.push(prodRecommended5);
            }
        }
        if (answer1 == 2) {
            goodProducts.push(prodRecommended6, prodRecommended7);
        }
        //1 -3
        if (answer1 == 3) {
            goodProducts.push(prodRecommended6, prodRecommended8);
        }
  
  
  
        if (answer6[0] != 8 && answer3 <= 2)
            goodProducts.push(prodRecommended1, prodRecommended9);
        else if (answer6[0] == 8 && answer3 <= 2)
            goodProducts.push(prodRecommended3, prodRecommended4);
        if (answer6[0] != 8 && answer3 == 3)
            goodProducts.push(prodRecommended1, prodRecommended2);
        else if (answer6[0] == 8 && answer3 == 4)
            goodProducts.push(prodRecommended3, prodRecommended5);
  
  
  
  
        if (answer4 == 1) {
            if (answer8 == 1) {
                goodProducts.push(prodRecommended10);
            }
            goodProducts.push(prodRecommended11);
        }
        //4 -2
        if (answer4 == 2) {
            goodProducts.push(prodRecommended0);
        }
        //4 -3
        if (answer4 == 3) {
            goodProducts.push(prodRecommended0);
        }
        //4 -4
        if (answer4 == 4) {
            goodProducts.push(prodRecommended0);
        }
        //4 -5
        if (answer4 == 5) {
            goodProducts.push(prodRecommended0);
        }
  
  
  
  
  
        if ($.inArray('1', answer6) > -1) {
            goodProducts.push(prodRecommended12);
        }
        //6 -2
        if ($.inArray('2', answer6) > -1) {
            goodProducts.push(prodRecommended12);
        }
        //6 -3
        if ($.inArray('3', answer6) > -1) {
            goodProducts.push(prodRecommended13);
        }
        //6 -5
        if ($.inArray('5', answer6) > -1) {
            goodProducts.push(prodRecommended13);
        }
        //6 -6
        if ($.inArray('6', answer6) > -1) {
            goodProducts.push(prodRecommended13);
        }
        //6 -7
        if ($.inArray('7', answer6) > -1) {
            goodProducts.push(prodRecommended13);
        }
  		//6 -8
        if ($.inArray('8', answer6) > -1) {
            goodProducts.push(prodRecommended14);
        }
  
  
  
        if (answer8 == 1) {
            goodProducts.push(prodRecommended10);
        }
        //8 -2
        if (answer8 == 2) {
            goodProducts.push(prodRecommended0);
        }
        //8 -3 || 8 -4
        if (answer8 == 3 || answer8 == 4) {
            goodProducts.push(prodRecommended15);
        }
  
  
  
        //9 -1
        if ((answer9.length > 0) && ($.inArray('1', answer9) > -1)) {
             //if thin or spare hair and shine give them hyd. milk
        if (answer3 < 3) {
            goodProducts.push(prodRecommended15);
        }else{
          
            goodProducts.push(prodRecommended11);
          	goodProducts.push(prodRecommended11);
          	goodProducts.push(prodRecommended11);
        } 
        }
        //9 -2
        if ((answer9.length > 0) && ($.inArray('2', answer9) > -1)) {
            goodProducts.push(prodRecommended15);
        }
        //9 -3
        if ((answer9.length > 0) && ($.inArray('3', answer9) > -1)) {
            goodProducts.push(prodRecommended10);
        }
        //9 -4
        if ((answer9.length > 0) && ($.inArray('4', answer9) > -1)) {
            goodProducts.push(prodRecommended0);
        }
        //9 -5
        if ((answer9.length > 0) && ($.inArray('5', answer9) > -1)) {
            goodProducts.push(prodRecommended0);
        }
        //9 -6
        if ((answer9.length > 0) && ($.inArray('6', answer9) > -1)) {
            goodProducts.push(prodRecommended15);
        }
  
  
  
  
        if (
            ($.inArray(prodRecommended12, goodProducts) > -1)) {
            //3 -1
            if (answer3 <= 2) {
                alwaysProducts.push(prodRecommended1, prodRecommended9);
            } else {
                alwaysProducts.push(prodRecommended1, prodRecommended2);
            }
        }
        //loop through if: Always Damage Repair .  do x y z
        //only show :  prodRecommended6,prodRecommended7?
        if ($.inArray(prodRecommended13, goodProducts) > -1) {
            //1 -2
            if (answer1 < 3) {
                alwaysProducts.push(prodRecommended6, prodRecommended7);
            }
            //1 -3
            if (answer1 == 3) {
                alwaysProducts.push(prodRecommended6, prodRecommended8);
            }
        }
        //loop through if: Always Moisturizing .  do x y z
        //only show :  prodRecommended3,prodRecommended5?
        //   alert($.inArray(prodRecommended14, goodProducts) );
        if ($.inArray(prodRecommended14, goodProducts) > -1) {
            //3 -1
            if (answer3 <= 2) {
                if (answer6[0] == 8) {
                    alwaysProducts.push(prodRecommended3, prodRecommended4);
                }
            }
            //3 -3
            if (answer3 > 2) {
                if (answer6[0] == 8) {
                    alwaysProducts.push(prodRecommended3, prodRecommended5);
                }
            }
        }
        var occurences = [];
        for (var i = 0; i < goodProducts.length; i++) {
            var key = goodProducts[i];
            occurences[key] = (occurences[key]) ? occurences[key] + 1 : 1;
        }
        var occurencesSort = Object.keys(occurences).map(function(key) {
            return {
                word: key,
                count: occurences[key]
            };
        });
  
    shuffle(occurencesSort);
  
  
        occurencesSort.sort(function(a, b) {
            return b.count - a.count
        });
       
        if ((alwaysProducts).length > 0) {
          resultText.push(alwaysProducts[0]);
          resultText.push(alwaysProducts[1]);
          
//             resultText = "Shampoo: " + alwaysProducts[0] + "<br/>";
//             resultText += "Conditioner: " + alwaysProducts[1] + "<br/>";
        } else {
            occurencesSort.forEach(function(key, value) {
                if (setShampoo == 0) {
                    if (key.word.indexOf('Shampoo') != -1) {
                        resultText.push(key.word);
                        //resultText += "Shampoo: " + key.word + "<br/>";
                        setShampoo = 1;
                        return 0;
                    }
                }
                if (setConditioner == 0) {
                    if (key.word.indexOf('Conditioner') != -1) {
                        resultText.push(key.word);
                        //resultText += "Conditioner: " + key.word + "<br/>";
                        setConditioner = 1;
                        return 0;
                    }
                }
            });
        }
  
  

  
  

        occurencesSort.forEach(function(key, value) {
           
            if (setFlag == 0) {
                if (!resultText.includes(key) && key.word.indexOf('Shampoo') == -1 && key.word.indexOf('Condition') == -1 && key.word.indexOf('Always') == -1) {
                    resultText.push(key.word);
                  //resultText += "Treatment/Styling: " + key.word + "<br/>";
                    setFlag = 1;
                    return 0;
                }
            }
        });
        
  // Identifying a person and tracking special Klaviyo properties.

  
pushItems = {
    'BNSTYLE-Q1' : answer1,
    'BNSTYLE-Q2' : answer3,
    'BNSTYLE-Q3' : answer4,
    'BNSTYLE-Q4' : answer5,
    'BNSTYLE-Q5' : answer6.toString(),
    'BNSTYLE-Q6' : answer8,
    'BNSTYLE-Q7' : answer9.toString(),
    'BNSTYLE-Q-Result' : resultText
  };

  

  	//console.log(resultText);
  	//console.log(occurencesSort);
  	//console.log(occurences);
  
      var resultProductWraper = $("#shopify-section-quiz-result .top-block").find(".product-lisiting-outer .home-care-product-wrapper");
      $(".hair-care-matches-page").removeClass("hide");
      
      resultProductWraper.find(".product_care_item").each(function(){
        var handle = $(this).attr("data-handle");
        var e1 = $(this).addClass("hide");
	    	var quiztext = $(this).find('.quizText')
  
        resultText.forEach(function(key, value) {
        
          if(handle == key.toLowerCase().replace(/\s/g,'-')){
            e1.removeClass("hide");
            $('.quiz-bullets').append( "<li>"+quiztext.text()+"</li>" );
          }
        });
      });   
  
  
 
  
  
  
      setTimeout(function(){
        equalHeights(".product_care_item .product-title");
      }, 2100);
   

    var originalPrice = 0, salePrice = 0, price_o = 0, price_s = 0, idArray = [];
    resultProductWraper.find(".product_care_item").each(function(){
      if($(this).hasClass("hide") == false) {
        var currentPrice = $(this).find(".home-product-inner-wrapper h3");

        if(currentPrice.find(".regular-price").hasClass("strike-through")) {
          price_o = currentPrice.find(".regular-price strike").text().replace("$", "");
        }
        else {
          price_o = currentPrice.find(".regular-price.sale-price").text().replace("$", "");
        }

        originalPrice = originalPrice + parseFloat(price_o);

        price_s = currentPrice.find(".regular-price.sale-price").text().replace("$", "");
        salePrice = salePrice + parseFloat(price_s);

        if(originalPrice == salePrice){
          $("#shopify-section-quiz-result .top-block").find(".product-lisiting-outer .subtotal .subtotal-text").html("Subtotal: <em>$"+salePrice+"</em>");
        }
        else {
          $("#shopify-section-quiz-result .top-block").find(".product-lisiting-outer .subtotal .subtotal-text").html("Subtotal: <s>$"+originalPrice+"</s> <em>$"+salePrice+"</em>");
        }
       
      }
      else {
        $(this).remove();
      }
    }); 
    home_care_product_wrapper();
    $(window).resize(function(){
      // if ($(".home-care-product-wrapper").length) {
      //   $(".home-care-product-wrapper").slick('resize');
      // }
      setTimeout(function(){
        home_care_product_wrapper();
      },500);
    });
  
  
  
  
    $("#shopify-section-quiz-result .add-regiemen-btn").click(function(){
      
      idArray = [];
      $(this).html('Please wait.... Adding to Cart');
      var resultProductWraper = $("#shopify-section-quiz-result .top-block").find(".product-lisiting-outer .home-care-product-wrapper");
      
      resultProductWraper.find(".product_care_item").each(function(){
        tmp = $(this)[0];
        idArray.push( $(tmp).data("variant-id"));
      });

      ajaxMultiBuy(idArray);
    });   
  
    ajaxMultiBuy=function(o){
     
     
      if(o.length != 0 ){
        var a=o.shift();
         //console.log("/cart/add/?id="+a+"&quantity=1");
        
        
        $.ajax({
          type:"GET",
          url:"/cart/add/?id="+a+"&quantity=1",
          dataType:"HTML", 
          success:function(){
            ajaxMultiBuy(o);
          },
          error:function(error){   
            addToCartFail();
            ajaxMultiBuy(o);
          }
        });
      }
      else {
         setTimeout(function(){
       	//sellify.ucd.helpers.ajaxCart.show();
          // $('.js-ajax-cart-drawer-trigger').click();
          // sellify.ucd.helpers.ajaxCart.load(true);
           
         //  addToCartOk();
           window.HS_SLIDE_CART_UPDATE(displayCartAfter);
           
          
           
            $("#shopify-section-quiz-result .add-regiemen-btn").html('Add Regimen To cart');
      }, 1000);
        
        //return false;
      }
    }
    $('form')[0].reset();
}

function displayCartAfter(){
   window.HS_SLIDE_CART_OPEN();
}

function shuffle(array) {
  array.sort(() => Math.random() - 0.5);
}

/*** For mobile view slider  ***/
function home_care_product_wrapper() {
  if ($(window).width() < 768) {
    if (!homeCare_product_wrapper) {
      $(".home-care-product-wrapper").slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 9999,
            settings: "unslick"
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
      homeCare_product_wrapper = true;
    }
  } else if ($(window).width() > 767) {
    if (homeCare_product_wrapper) {
      $(".home-care-product-wrapper").slick('unslick');
      homeCare_product_wrapper = false;
    }
  }
}

/***Document Ready***/
$(document).ready(function () {
  
  var stepNo=0;
  if($('.quiz-step-content-block').length){
     $('.quiz-step-content-block').attr('tabindex','-1');
    	$('.quiz-step-content-block .quiz-listing li .custom-radio-outer input').attr('tabindex','-1');
  }
  $('#quiz-step').focus(function(){
     $(this).find('.quiz-step-content-block.current .quiz-listing li:first-child .custom-radio-outer').focus();
  });
  


  //Quiz validation
  var form = $("#quiz-step").show();
   
  form.validate({
    
    showErrors: function(errorMap, errorList) {

     if(errorList.length < 1 || errorList == undefined){
       if(stepNo == 6)
          $('.finish-btn').show();
       else
        $('.next-step').show();
     }else{
          $('.finish-btn').hide();
       $('.next-step').hide(); 
     }
    },
    success: function(){
       $('.error-section').text('');
      $('.error-section').hide();
    },
    errorPlacement: function errorPlacement(error, element) {

        $('.error-section').text("Please select at least one option");
       $('.error-section').show();
      
      //$('.quiz-listing').before(error);

    }
 });
  
  form.children("div").steps({
    headerTag: ".step_navigation",
    bodyTag: ".quiz-step-content-block",
    transitionEffect: "slideLeft",
     titleTemplate: '<span class="number">Step #index#.</span>#index#',
    stepsContainerTag: "div",
    onInit: function (event, current) {
      $('.actions > ul > li:first-child').attr('class','first-step back-step');
      $('.actions > ul > li:nth-child(2)').attr('class','next-step');  
      $('.actions > ul > li:nth-child(2) a').removeAttr('role');
       $('.actions > ul > li:nth-child(2)').css('display','none');
      $('.actions > ul > li:last-child').attr('class', 'finish-btn');     
      $('.actions > ul > li:last-child').attr('role', 'presentation');     
      $('.actions > ul > li:last-child a').attr('class', 'next-btn submit-btn');
      $(".steps li").each(function(){
          $(this).attr('tabindex','0');
          $(this).find('a').attr('tabindex','-1');
    });
     $(window).bind('keydown', function (e) {
      if (e.keyCode == 32) {
          $(".quiz-listing .custom-radio-outer").each(function () {
              var _this = $(this);
              if (_this.is(':focus')) {
                  if (_this.parent('.quiz-listing').hasClass('normal-listing')) {
                      _this.find('.custom_input').prop("checked", !_this.find('.custom_input').prop("checked"));
                  }
                  else {
                      e.preventDefault();
                      _this.find('.custom_input').click();
                  }
              }
          });
      }
      if (e.keyCode == 13) {
          $(".steps li").each(function () {
              var _this = $(this);
              if (_this.is(':focus')) {
                  _this.find('a').click();
              }
          })
      }
       if(e.keyCode == 9){
         
         if($('.quiz-steps-wizard .steps ul li:last-child').is(':focus')) {
            $('.footer-content-wrapper .custom-input input').focus();
          
        }
      
       }
      
  });
      
      	$('.quiz-steps-wizard .actions ul li.next-step a').keydown(function(e) {
          if(e.keyCode == 9) {
            $('.quiz-steps-wizard .steps ul').find('li').eq(0).focus();
          }
        });
      	$('.quiz-steps-wizard .actions ul li.finish-btn a').keydown(function(e) {
          if(e.keyCode == 9) {
            $('.quiz-steps-wizard .steps ul').find('li').eq(0).focus();
          }
        });
      
      
      	$('.quiz-steps-wizard .actions ul li.back-step a').keydown(function(e) {
        if(e.keyCode == 9) {
          
          if($('.quiz-steps-wizard .actions ul li.next-step').is(':hidden') && $('.quiz-steps-wizard .actions ul li.finish-btn').is(':visible')) {
           $('.quiz-steps-wizard .actions ul li.finish-btn').focus();
          
          }
           else if($('.quiz-steps-wizard .actions ul li.next-step').is(':hidden') && $('.quiz-steps-wizard .actions ul li.finish-btn').is(':hidden')){
             $('.quiz-steps-wizard .steps ul').find('li').eq(0).focus();
           }
        }
      });
     
    },
    labels: {
      next: "NEXT",
      previous: "Back",
      finish : "Get Results"
    },
    onStepChanging: function (event, currentIndex, newIndex)
    {
      
      if(newIndex > currentIndex){
      form.validate().settings.ignore = ":disabled,:hidden";
      form.validate().settings.errorElement = "div";
        stepNo = currentIndex;
      return form.valid();
      }
      else{
       return true; 
      }
    },
    onFinishing: function (event, currentIndex)
    {
        form.validate().settings.ignore = ":disabled";
        form.validate().settings.errorElement = "span";
      stepNo=currentIndex;
        return form.valid();
    }
  }).on("stepChanged", function (event, currentIndex) {
     stepNo=currentIndex;
    form.valid();
    
    var content_height = $("#step-content-block-p-" + currentIndex)[0].scrollHeight;
    $(".quiz-section .quiz-inner-content .quiz-steps-wizard .content").css("min-height", content_height);
    if (currentIndex == 0) {
      $(".quiz-content-wrapper").addClass("previous-content");
    } else {
      $(".quiz-content-wrapper").removeClass("previous-content");
    }
  
        
  }).on("finished", function(event, currentIndex){
     $(this).parents(".quiz-inner-content").fadeOut();
     $(this).parents(".quiz-inner-content").next().fadeIn();
     quizLogic();  
    $('#shopify-section-quiz-result').hide(); 
     
    
     setTimeout(function(){
       
      $('.quiz-page').fadeOut(500, function () {
        
          $('#shopify-section-quiz-result').fadeIn();

        sameHeights(".product_care_item .home-product-inner-wrapper .product-title");
        sameHeights(".product_care_item .home-product-inner-wrapper");

        //$('.quizname').text($('#user-name').val());
          
               
        
      });
       
        }, 5000);
    
      setTimeout(function(){
        $(window).resize();
      }, 6000);
  
//     equalHeights();  
  });
  
  $(".hair-care-matches-page").addClass("hide"); 
    $(".quiz-steps-wizard .actions ul li.next-step a, .quiz-section .quiz-inner-content .next-btn ,.quiz-steps-wizard .actions ul li.back-step a,.quiz-steps-wizard .steps ul li a ").click(function () {
      if($(window).scrollTop() > $('.quiz-page').offset().top){
            $("body,html").animate({
                scrollTop: 0
            }, 100) 
      } 
     // $(this).closest('.quiz-section').find('.quiz-step-content-block.current .quiz-listing li:first-child .custom-radio-outer').focus();

    });
  
    //Default create Slick structure of product listed...

    // setTimeout(function(){
        // if ($(".home-care-product-wrapper").length) {
        //     $(".home-care-product-wrapper").slick('resize');
        //   } 
    // },5000);

    jQuery(window).on("orientationchange", function () {
      setTimeout(function(){
        home_care_product_wrapper();
      },500);
    });

});